module.exports = __webpack_public_path__ + "static/media/header_desktop.87fd29c3.png";